/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useForm, useAndes, useFundsOut, useBlockings, useAuth } from '@hooks';
import { isAllowed } from '@helpers/auth';
import Withdrawals from '@components/Withdrawals';
import BankAccount from '@components/BankAccount';
import BlockScreen from '@components/BlockScreen';
import { getEnv } from '@config';
import SkeletonDoFoundsOut from './index.skeleton';

const DoFoundsOut = () => {
  const { transactionInProgress } = useSelector((state) => state.transactions);
  const { isSeller } = useAuth();
  const { enabledBlockingFundsOutForAll } = getEnv();
  const { bankAccount, withdraw, getDayLimit } = useFundsOut();
  const { availableIncome, getBalances } = useAndes(null);
  const [hasError, setHasError] = useState(false);
  const { handleInputChange, formValues } = useForm({ amount: 0 });
  const blockingsAllowed =
    isAllowed('FINANCING_BLOCKINGS') && (enabledBlockingFundsOutForAll === 'true' || isSeller());
  const { getBlockings, blockings, blockingDetails } = useBlockings();

  useEffect(() => {
    getBalances();
  }, [getBalances]);

  useEffect(() => {
    if (blockingsAllowed) {
      getBlockings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockingsAllowed]);

  const isBlock = blockingsAllowed && blockings.includes('FUNDS_OUT');

  const handleWithdraw = () => {
    withdraw(formValues.amount, getDayLimit());
    setHasError(true);
  };

  const isValidAmount = (amount) => {
    setHasError(true);
    return amount <= availableIncome;
  };
  if (transactionInProgress) {
    return <SkeletonDoFoundsOut />;
  }

  return (
    <>
      {isBlock ? (
        <BlockScreen
          blockingDetails={blockingDetails.find((detail) => detail.name === 'FUNDS_OUT')}
        />
      ) : (
        <>
          <Withdrawals
            htmlIdButtonSuccess="withdraw-money-funds-out-do"
            htmlIdButtonCancel="cancel-money-withdrawal-funds-out-do"
            htmlIdRadioButton="radio-withdraw-money-funds-out-do"
            balances={{
              available: availableIncome,
              dayLimit: getDayLimit(),
            }}
            bankAccount={bankAccount}
            handleChange={(event) => {
              if (hasError) {
                setHasError(false);
              }
              handleInputChange(event);
            }}
            amount={formValues.amount}
            handleWithdraw={handleWithdraw}
            hasError={hasError}
            childComponent={
              <BankAccount htmlIdButtonNotAddedAccount="add-bank-account-funds-out-do" />
            }
            isValidAmount={isValidAmount}
          />
        </>
      )}
    </>
  );
};

export default DoFoundsOut;
